<template>
    <b-card>
        <b-row>
            <b-col style="text-align: left; font-weight: bold; font-size: 20px">
                ŞUBE OLUŞTURMA
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col style="text-align: left; font-weight: bold">
                <span>Şube Adı</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <b-form-input v-model="name" @focus.native="errors.name = false" :class="{'is-invalid': errors.name }"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>Veri Tipleri</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="12" md="6" lg="2">
                <multiselect
                    :class="{'is-invalid': errors.dataTypes}"
                    @focus.native="errors.dataTypes = false"
                    v-model="dataTypes"
                    :multiple="true"
                    :options="allDataTypesOptions"
                    :close-on-select="true"
                    :showLabels="false"
                    :placeholder="$t('choose')"
                    label="name"
                    track-by="id">
                </multiselect>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>Şehir</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <b-form-select v-model="cityCode" @focus.native="errors.cityCode = false" :class="{'is-invalid': errors.cityCode }">
                    <option :value="null" :disabled="true">{{ $t('choose') }}</option>
                    <option v-for="city in $store.state.cities" :value="city.code">{{ city.name }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>Bölge</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <b-form-select v-model="region" @focus.native="errors.region = false" :class="{'is-invalid': errors.region }">
                    <option :value="null" :disabled="true">{{ $t('choose') }}</option>
                    <option v-for="group in siteGroups" :value="group.id">{{ group.display_name }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>Kod</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <b-form-input v-model="code" @focus.native="errors.code = false" :class="{'is-invalid': errors.code }"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>Alan</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <b-form-input v-model="area" @focus.native="errors.area = false" :class="{'is-invalid': errors.area }" type="number"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('number of people') }}</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <b-form-input v-model="staffCount" @focus.native="errors.staffCount = false" :class="{'is-invalid': errors.staffCount }" type="number"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>Koordinat</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6" md="3" lg="1">
                <b-form-input v-model="lat" @focus.native="errors.lat = false" :class="{'is-invalid': errors.lat }" placeholder="lat" type="number"/>
            </b-col>
            <b-col cols="6" md="3" lg="1">
                <b-form-input v-model="lng" @focus.native="errors.lng = false" :class="{'is-invalid': errors.lng }" placeholder="lng" type="number"/>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col cols="12" md="6" lg="2">
                <b-row align-h="end">
                    <b-col cols="12" md="8" lg="8">
                        <button class="btn btn-lg btn-primary btn-block" @click="update()">{{ $t("create") }}</button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
    name: 'SiteCreate',
    components: {
        Multiselect
    },
    data() {
        return {
            name: null,
            code: null,
            area: null,
            staffCount: null,
            lat: null,
            lng: null,
            cityCode: null,
            region: null,
            dataTypes: [],
            allDataTypesOptions: [],
            errors: {
                name: false,
                code: false,
                area: false,
                staffCount: false,
                lat: false,
                lng: false,
                cityCode: false,
                region: false,
                dataTypes: false
            }
        };
    },
    methods: {
        validate() {
            for (let key in this.errors) {
                this.errors[key] = !this[key];
            }
            // checks true value count of erros object
            return !Object.values(this.errors).filter(value => {
                return !!value;
            }).length;
        },
        update() {
            if (this.validate()) {
                let site = {
                    name: this.name,
                    code: this.code,
                    area: this.area,
                    staffCount: this.staffCount,
                    lon: this.lng,
                    lat: this.lat,
                    city: this.cityCode,
                    site_group_id: this.region,
                    dataTypes: this.dataTypes.map(dataType => dataType.id)
                };
                this.$Progress.start();
                return this.axios.post(`/sites`, site).then(() => {
                    let PromiseArr = [
                        this.$store.dispatch('init'),
                        this.$store.dispatch('getDocumentCounts', this.year),
                        this.$store.dispatch('getGoalCounts', this.year),
                        this.$store.dispatch('getAuditCounts', this.year)
                    ];
                    return Promise.all(PromiseArr).then(() => {
                        this.$Progress.finish();
                        this.$router.push({name: 'admin-site'});
                    });
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        }
    },
    created() {
        this.allDataTypesOptions = this.$store.state.dataTypes;
        this.allDataTypesOptions.forEach(dataType => {
            dataType.name = this.$t(dataType.name);
        });
    }
};
</script>

<style scoped>
</style>

<style lang="scss">
.multiselect__tags {
    padding: 12px 30px 0 8px;
    background: white;
    border: 1px solid #ced4da;
    input::placeholder {
        color: #696969;
    }
    .multiselect__single {
        font-size: 1em;
        color: black;
        background: white;
    }
    .multiselect__input {
        font-size: 1em;
        color: black;
        background: white;
    }
    .multiselect__tag {
        position: relative;
        display: inline-block;
        padding: 4px 26px 4px 10px;
        border-radius: 5px;
        margin-right: 10px;
        color: #fff;
        line-height: 1;
        background: #868e96;
        margin-bottom: 5px;
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        .multiselect__tag-icon:after {
            content: '\D7';
            color: #3f424a;
            font-size: 14px;
        }
    }
}
.multiselect__option--highlight {
    background: #868e96;
    outline: none;
    color: white;
}
</style>

<i18n src="../../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/views/Setting/SiteCreate.vue